



















import Ellipsis from "@/components/Ellipsis.vue";
import { Simulation } from "@/api/custom-simulation";
import moment from "moment";
import Vue, { PropType } from "vue";
import { FinishStatus, FinishStatusText } from "@/constants/custom-simulation";

export default Vue.extend({
    props: {
        item: { type: Object as PropType<Simulation> }
    },
    data() {
        return {
            defaultCover: require("../../assets/product_thumbnail.png")
        };
    },
    methods: {
        formatTime(val) {
            return moment(val).format("YYYY.MM.DD");
        },
        getFinishStatus(val) {
            return FinishStatusText[val];
        },
        getFinishStatusClass(val) {
            switch (val) {
                case FinishStatus.notStart:
                    return "notStart";
                case FinishStatus.studying:
                    return "studying";
                case FinishStatus.finished:
                    return "finished";
                default:
                    return "";
            }
        },
        async handleOpenSimulation() {
            this.$store.commit("customSimulationModule/setCurrentSimulation", this.item);
            await this.$store.dispatch("customSimulationModule/getSimulationDetail", {
                designTaskId: this.item.id
            });
            if (this.item.designFinishStatus === FinishStatus.notStart) {
                await this.$store.dispatch("customSimulationModule/changeLearningStatus", {
                    designTaskId: this.item.id,
                    status: FinishStatus.studying,
                    targetId: this.$store.state.user.userId,
                    step: this.item.step
                });
            }
            this.$router.push({ path: "/simulationHomePage" });
        }
    },
    components: { Ellipsis }
});
